// extracted by mini-css-extract-plugin
export var layoutContainer = "style-module--layoutContainer--5418a";